import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { ButtonStyle } from '@website-builder/widgets/button/model/button-style';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { ButtonElement } from '@website-builder/widgets/button/button-element';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class ButtonWidget extends BaseMultipleWidget<ButtonElement, ButtonStyle> {
  readonly type = BuilderElementType.Button;
  style = new ButtonStyle();

  elements = [new ButtonElement(), new ButtonElement(), new ButtonElement()];

  static normalizeInPlace(widget: ButtonWidget): ButtonWidget {
    const pureWidget = new ButtonWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.elements = (widget.elements ?? pureWidget.elements).map(element => ButtonElement.normalizeInPlace(element));

    widget.style = ButtonStyle.normalize(widget.style);

    return widget;
  }
}
